import { useMemo } from 'react'
import { useDispatch } from 'react-redux'

import { Button, Box, Flex, Text, Tooltip } from '@chakra-ui/react'
import { isNullish } from '@/utils/helper'

//Slice
import { setFileHistoryModal } from '@/stores/ui/uiSlice'
import { useTranslation } from 'react-i18next'

const ViewFileHistoryModalButton = ({ fileDetails, fileType, showFileName = true }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  //Translated
  const fileCount = Array.isArray(fileDetails) ? fileDetails.length : 0

  const lastFileName = useMemo(() => {
    if (!Array.isArray(fileDetails)) {
      return '(-)'
    }

    const latestVersion = Math.max(...fileDetails.map((file) => (isNullish(file?.version) ? -1 : file.version)))

    return fileDetails
      .filter((file) => file?.version === latestVersion)
      .map((file) => file?.originalFileName || '')
      .join(', ')
  }, [fileDetails])

  const viewFileDetail = () => {
    dispatch(
      setFileHistoryModal({
        show: true,
        title: t('BUTTON_DETAIL'),
        files: fileDetails,
        canEdit: false,
        fileType: fileType,
      })
    )
  }

  return (
    <Flex gap="2" alignItems={'center'}>
      {fileCount === 0 && <Box>({t('BUTTON_NO_FILE')})</Box>}
      {fileCount > 0 && (
        <>
          <Button colorScheme="blue" onClick={() => viewFileDetail()}>
            {t('BUTTON_DETAIL')}({fileCount})
          </Button>

          {showFileName && (
            <Tooltip label={lastFileName}>
              <Text overflow={'clip'} noOfLines={1}>
                {lastFileName}
              </Text>
            </Tooltip>
          )}
        </>
      )}
    </Flex>
  )
}

export default ViewFileHistoryModalButton
